// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wcm-modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
}

.wcm-modal-content {
    background-color: white;
    padding: 40px;
    border-radius: 8px;
    text-align: center;
    width: 400px;
}

.wcm-modal-title {
    font-size: 24px;
    font-weight: 500;
    margin: 0 0 10px 0;
}

.wcm-modal-text {
    font-size: 16px;
    color: #555;
    margin: 0 0 30px 0;
}

.wcm-modal-actions {
    display: flex;
    justify-content: center;
    gap: 10px;
}

.wcm-modal-actions button {
    padding: 12px 40px;
    font-size: 16px;
    font-weight: 500;
    border-radius: 5px;
    cursor: pointer;
}

.wcm-btn-cancel {
    background-color: #222;
    color: white;
    border: none;
}

.wcm-btn-confirm {
    background-color: white;
    color: #333;
    border: 1px solid #ccc;
}

/* Mobile devices */
@media (max-width: 768px) {
    .wcm-modal-content {
        width: 90%;
        padding: 30px 20px;
    }

    .wcm-modal-title {
        font-size: 20px;
    }

    .wcm-modal-text {
        font-size: 15px;
    }

    .wcm-modal-actions {
        flex-direction: column;
    }

    .wcm-modal-actions button {
        width: 100%;
        padding: 12px;
    }
} `, "",{"version":3,"sources":["webpack://./src/components/css/WithdrawalConfirmModal.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,oCAAoC;IACpC,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,uBAAuB;IACvB,aAAa;IACb,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,sBAAsB;IACtB,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,uBAAuB;IACvB,WAAW;IACX,sBAAsB;AAC1B;;AAEA,mBAAmB;AACnB;IACI;QACI,UAAU;QACV,kBAAkB;IACtB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,WAAW;QACX,aAAa;IACjB;AACJ","sourcesContent":[".wcm-modal-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: rgba(0, 0, 0, 0.5);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 1000;\n}\n\n.wcm-modal-content {\n    background-color: white;\n    padding: 40px;\n    border-radius: 8px;\n    text-align: center;\n    width: 400px;\n}\n\n.wcm-modal-title {\n    font-size: 24px;\n    font-weight: 500;\n    margin: 0 0 10px 0;\n}\n\n.wcm-modal-text {\n    font-size: 16px;\n    color: #555;\n    margin: 0 0 30px 0;\n}\n\n.wcm-modal-actions {\n    display: flex;\n    justify-content: center;\n    gap: 10px;\n}\n\n.wcm-modal-actions button {\n    padding: 12px 40px;\n    font-size: 16px;\n    font-weight: 500;\n    border-radius: 5px;\n    cursor: pointer;\n}\n\n.wcm-btn-cancel {\n    background-color: #222;\n    color: white;\n    border: none;\n}\n\n.wcm-btn-confirm {\n    background-color: white;\n    color: #333;\n    border: 1px solid #ccc;\n}\n\n/* Mobile devices */\n@media (max-width: 768px) {\n    .wcm-modal-content {\n        width: 90%;\n        padding: 30px 20px;\n    }\n\n    .wcm-modal-title {\n        font-size: 20px;\n    }\n\n    .wcm-modal-text {\n        font-size: 15px;\n    }\n\n    .wcm-modal-actions {\n        flex-direction: column;\n    }\n\n    .wcm-modal-actions button {\n        width: 100%;\n        padding: 12px;\n    }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
